module.exports = __webpack_public_path__ + "img/learn-2-dark.24ac8790.png";